import MigrationMessagingBanner from 'ui-addon-conversations-settings/help-desk-migration/components/MigrationMessagingBanner';
import { useChatflow } from 'ui-addon-conversations-settings/help-desk-migration/hooks/useChatflow';
import { getChatflowMigrationStatusUrl } from '../../../urls/getHelpDeskMigrationUrl';
import { jsx as _jsx } from "react/jsx-runtime";
const ChatflowMigrationBanner = ({
  channel
}) => {
  const {
    chatflow
  } = useChatflow({
    channelInstanceId: channel.channelInstanceId
  });
  if (!chatflow) {
    return null;
  }
  return /*#__PURE__*/_jsx(MigrationMessagingBanner, {
    channel: channel,
    viewStatusRoute: getChatflowMigrationStatusUrl(chatflow.id)
  });
};
ChatflowMigrationBanner.displayName = 'ChatflowMigrationBanner';
export default ChatflowMigrationBanner;